import React from 'react'
import { Button, Col, Row } from 'antd'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { CloseOutlined } from '@ant-design/icons'

export const LinkWizardHeaderControls = ({ closeSlideUp }) => {
  return (
    <Horizontal
      border='all'
      bg='elevated'
      flex='0'
      style={{ overflow: 'visible' }}
      className='dispatch-toolbar px-4 link-wizard'
    >
      <Col flex={1} className='flex-div items-center'>
        <Texto category='h5' className='grid-count'>
          Link Order{' '}
        </Texto>
      </Col>

      <Col align='right' className='flex-div items-center' style={{ justifyContent: 'flex-end' }}>
        <div className='time-frame-control'>
          <GraviButton icon={<CloseOutlined />} className='shift-select-button ' onClick={() => closeSlideUp()}>
            Close
          </GraviButton>
        </div>
      </Col>
    </Horizontal>
  )
}
